import { Component } from '@angular/core';
import { CommonModule } from '@angular/common';

@Component({
    selector: 'ce-layout-header-container',
    standalone: true,
    imports: [CommonModule],
    templateUrl: './header-container.component.html',
    styleUrl: './header-container.component.scss',
})
export class HeaderContainerComponent {}
